import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    // 处理锚点滚动
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
        offset: { y: 80 },
      };
    }
    return { x: 0, y: 0 };
  },
});

export default router;
